import { Link } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

export default function CategoryNav() {
  const categoryIcons: Record<string, string> = {
    hot: 'ri-fire-line',
    chinese: 'ri-building-2-line',
    korean: 'ri-earth-line',
    american: 'ri-global-line',
    japanese: 'ri-earth-line',
    variety: 'ri-tv-2-line',
    anime: 'ri-ghost-line',
  };

  return (
    <section className="py-10 md:py-14">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-6">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            按类型找到你喜欢的剧集
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${categoryIcons[cat.slug] || 'ri-folder-line'} text-lg`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}